import React from 'react';
import { RouteComponentProps, Route } from 'react-router-dom';

import { concatUrl, readPathId } from 'modules/shared/utils';
import { StructureNavigationProps } from 'modules/shared/types';
import { NotifiedRoute, UnknownContent } from 'modules/shared/components';

import {
    WeddingLandingPage,
    WeddingLanding2Page,
    TripLandingPage,
    WeddingEditorialLandingPage,
    PersonalizedAdvicePage,
    DressLandingPage,
    DressesPage,
    DressPage,
    CreatorsPage,
    CreatorPage,
    AppointmentPage,
    AppointmentCreationPage,
    ManageAppointmentPage,
    EventPage,
    VoyagePage,
} from '../../../../pages';

export const ContentSelector: React.FC<StructureNavigationProps> = ({
    template,
    navigationTree,
    ...rest
}: StructureNavigationProps) => {
    switch (template) {
        case 'mariage-landing':
            return <WeddingLandingPage {...rest} />;
        case 'mariage-landing-2':
            return <WeddingLanding2Page {...rest} />;
        case 'voyage-landing':
            return <TripLandingPage {...rest} />;
        case 'liste-voyage':
            return <VoyagePage {...rest} />;
        case 'edito-mariage-landing':
            return <WeddingEditorialLandingPage {...rest} />;
        case 'conseils-personnalises':
            return <PersonalizedAdvicePage {...rest} />;
        case 'robes-landing':
            return <DressLandingPage {...rest} />;
        case 'event-landing':
            return <EventPage {...rest} />;
        case 'liste-createurs':
            return (
                navigationTree && (
                    <React.Fragment>
                        <NotifiedRoute
                            exact
                            path={navigationTree.path}
                            navigationTree={navigationTree}
                            render={() => {
                                return <CreatorsPage {...rest} />;
                            }}
                        />
                        <Route
                            exact
                            path={concatUrl([navigationTree.path, '/:creator'])}
                            render={(subProps: RouteComponentProps<{ creator: string }>) => {
                                return (
                                    <CreatorPage
                                        filterParams={[
                                            { key: 'brandId', value: readPathId(subProps.match.params.creator) },
                                        ]}
                                        path={subProps.match.url}
                                        parentNavigationTree={navigationTree}
                                    />
                                );
                            }}
                        />
                        <Route
                            exact
                            path={concatUrl([navigationTree.path, '/:creator/:dress'])}
                            render={(subProps: RouteComponentProps<{ dress: string }>) => {
                                return (
                                    <DressPage
                                        id={readPathId(subProps.match.params.dress)}
                                        path={subProps.match.url}
                                        parentNavigationTree={navigationTree}
                                    />
                                );
                            }}
                        />
                    </React.Fragment>
                )
            );
        case 'liste-robes':
            return (
                navigationTree && (
                    <React.Fragment>
                        <NotifiedRoute
                            exact
                            path={navigationTree.path}
                            navigationTree={navigationTree}
                            render={() => {
                                return <DressesPage {...rest} />;
                            }}
                        />
                        <Route
                            exact
                            path={concatUrl([navigationTree.path, '/:dress'])}
                            render={(subProps: RouteComponentProps<{ dress: string }>) => {
                                return (
                                    <DressPage
                                        id={readPathId(subProps.match.params.dress)}
                                        path={subProps.match.url}
                                        parentNavigationTree={navigationTree}
                                    />
                                );
                            }}
                        />
                    </React.Fragment>
                )
            );
        case 'landing-appointment':
            return (
                <React.Fragment>
                    <NotifiedRoute
                        exact
                        path={navigationTree.path}
                        navigationTree={navigationTree}
                        render={() => {
                            return <AppointmentPage {...rest} />;
                        }}
                    />
                    <Route
                        exact
                        path={concatUrl([navigationTree.path, 'prise-rdv'])}
                        navigationTree={navigationTree}
                        render={() => (
                            <AppointmentCreationPage
                                id=""
                                path={concatUrl([navigationTree.path, 'prise-rdv'])}
                                parentNavigationTree={navigationTree}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={concatUrl([navigationTree.path, 'gerer-rdv'])}
                        navigationTree={navigationTree}
                        render={() => (
                            <ManageAppointmentPage
                                id=""
                                path={concatUrl([navigationTree.path, 'gerer-rdv'])}
                                parentNavigationTree={navigationTree}
                            />
                        )}
                    />
                </React.Fragment>
            );
        case 'corner-marque':
            return (
                <CreatorPage
                    path={navigationTree.path}
                    parentNavigationTree={navigationTree}
                    filterParams={[{ key: 'brandId', value: rest.id }]}
                />
            );
        case 'fiche-produit-robe':
            return <DressPage {...rest} path={navigationTree.path} parentNavigationTree={navigationTree} />;
        default:
            return <UnknownContent />;
    }
};
